import { DropdownMenuItem } from "@snap-mobile/snap-ui/dist/types/utils";
import useModal from "hooks/use-modal";
import { useEffect, useState } from "react";
import SwitchRole from "shared-components/modal/switch-role";
import { SnapGlobalHeader, SnapHeaderWrapper, SnapLogo } from "suit";
import GlobalToastMessage from "../global-toast-message";
import { TIER1, TIER2, TIER3, TIERS } from "../../constants";
import { useAppContexts } from "hooks/use-context";

function Header() {
  const { isOpen, toggle } = useModal();
  const { program, user, toast, split } = useAppContexts();
  const roles = user?.getAllRoles();
  const [roleOptions, setRoleOptions] = useState<DropdownMenuItem[]>([]);
  const [tempOptions, setTempOptions] = useState<DropdownMenuItem[]>([]); // FOR TESTING PURPOSES ONLY!!!!
  const [messagingEnabled, setMessagingEnabled] = useState(false);
  useEffect(() => {
    setMessagingEnabled(split?.isTreatmentOn(split?.act.se2136) || false);
  }, [split]);
  useEffect(() => {
    if (roles && roles.length > 1) {
      let name =
        user?._session?.role?.name
          .split("_")
          .map((word) => `${word[0].toUpperCase()}${word.substring(1)}`)
          .join(" ") ?? "";
      let currentRole: DropdownMenuItem = {
        name: name ?? "",
        text: name ?? "",
        value: name ?? "",
        selected: true,
      };
      let switchRole: DropdownMenuItem = {
        name: "Switch Role",
        text: "Switch Role",
        value: "Switch Role",
        selected: false,
      };

      setRoleOptions([currentRole, switchRole]);
    }

    if (split?.isTreatmentOn(split.act.enableSpendLite)) {
      let tierOptions: DropdownMenuItem[] = [
        {
          name: TIER1,
          text: TIER1,
          value: TIER1,
          selected: false,
        },
        {
          name: TIER2,
          text: TIER2,
          value: TIER2,
          selected: false,
        },
        {
          name: TIER3,
          text: TIER3,
          value: TIER3,
          selected: false,
        },
      ];
      setTempOptions(tierOptions);
    }
  }, [roles, program, user, split]);

  return (
    <>
      <SnapGlobalHeader theme="spend" className="fixed">
        <SnapLogo white={true} product="snap-logo-spend"></SnapLogo>
        <div className="flex">
          <SnapHeaderWrapper
            showMessaging={messagingEnabled}
            showLoginButtons={false}
            menuItems={[...roleOptions, ...tempOptions]}
            // menuItems={roleOptions}
            onSnap-header-session-item-selected={(e) => {
              if (e.detail.name === "Switch Role") {
                toggle();
              } else {
                program?.setTier(e.detail.name as (typeof TIERS)[number]);
              }
            }}
          ></SnapHeaderWrapper>
        </div>
        {toast?.isToastOpen && (
          <GlobalToastMessage
            title={toast.title}
            message={toast?.message}
            isToastOpen={toast?.isToastOpen}
            toggleToast={toast?.toggleToast}
            type={toast?.type}
            className={"mt-2"}
          />
        )}
      </SnapGlobalHeader>
      <SwitchRole
        isOpen={isOpen}
        toggle={toggle}
        currentRole={user?._session?.role}
        roles={roles}
      />
    </>
  );
}

export default Header;
